import { Plant, PlantsRequest } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum ActionTypes {
  FETCH_PLANTS = '[Bulk CEM UL Modify] Fetch Plants',
  ADD_PLANTS = '[Bulk CEM UL Modify] Add Plants',
  CLEAR_PLANTS = '[Bulk CEM UL Modify] Clear Plants',
}

export class FetchPlants implements Action {
  readonly type = ActionTypes.FETCH_PLANTS;
  constructor(public payload: { orderFormId: number; request: PlantsRequest; productId: number }) {}
}

export class AddPlants implements Action {
  readonly type = ActionTypes.ADD_PLANTS;
  constructor(public payload: { orderFormId: number; plants: Plant[] }) {}
}

export class ClearPlants implements Action {
  readonly type = ActionTypes.CLEAR_PLANTS;
  constructor(public payload: { orderFormId: number }) {}
}

export type Actions = FetchPlants | AddPlants | ClearPlants;
